/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { chatControllerGetHistory } from "./chatControllerGetHistory";
import { chatControllerGetRequestStatus } from "./chatControllerGetRequestStatus";
import { chatControllerStreamResponse } from "./chatControllerStreamResponse";
import { chatControllerSubmitQuery } from "./chatControllerSubmitQuery";

export function chatService() {
  return { chatControllerGetHistory, chatControllerSubmitQuery, chatControllerGetRequestStatus, chatControllerStreamResponse }
}